{
	"useSoilVolumeCalculation": true,
	"useSurfaceAreaCalculation": true
}
